// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-37db4382] {\n  margin-left: 250px;\n  margin-right: 250px;\n  max-width: calc(100vw - 300px);\n}\n.form-title[data-v-37db4382] {\n  display: flex;\n}\n.profile-item[data-v-37db4382] {\n  width: 50%;\n}", ""]);
// Exports
module.exports = exports;
